var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPoll = function SvgPoll(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    role: "presentation",
    "aria-hidden": true,
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3 9.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5V22H3zM17 13.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5V22h-4zM10 2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5V22h-4z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPoll);
export { ForwardRef as Icon };
export default "img/element-icons/room/composer/poll.a8ee2f3.svg";